package br.com.htms.inspeccaocampo.data

object RelSegJson {
    fun payloadToJson(p: RelSegPayload): String {
        val n = p.withDdsSize().withTreinamentosSize()
        return buildString {
            append('{')
            append("\"dadosGerais\":")
            append(dadosToJson(n.dadosGerais))
            append(',')
            append("\"gestaoSms\":")
            append(smsToJson(n.gestaoSms))
            append(',')
            append("\"dds\":[")
            n.dds.forEachIndexed { i, e ->
                if (i > 0) append(',')
                append('{')
                append("\"temaData\":"); append(jsonStr(e.temaData)); append(',')
                append("\"fotoRef\":"); append(jsonStr(e.fotoRef))
                append('}')
            }
            append("],")
            append("\"treinamentos\":[")
            n.treinamentos.forEachIndexed { i, t ->
                if (i > 0) append(',')
                append('{')
                append("\"treinamento\":"); append(jsonStr(t.treinamento)); append(',')
                append("\"nomes\":"); append(jsonStr(t.nomes)); append(',')
                append("\"data\":"); append(jsonStr(t.data)); append(',')
                append("\"numPessoas\":"); append(jsonStr(t.numPessoas)); append(',')
                append("\"descricao\":"); append(jsonStr(t.descricao)); append(',')
                append("\"fotos\":[")
                t.withFotosSize().fotos.forEachIndexed { j, ref ->
                    if (j > 0) append(',')
                    append(jsonStr(ref))
                }
                append(']')
                append('}')
            }
            append(']')
            append('}')
        }
    }

    fun payloadFromJson(raw: String?): RelSegPayload {
        if (raw.isNullOrBlank()) return RelSegPayload()
        val root = runCatching { JsonMap.parse(raw) }.getOrNull() ?: return RelSegPayload()
        return payloadFromMap(root)
    }

    internal fun payloadFromMap(root: JsonMap): RelSegPayload {
        val dg = root.obj("dadosGerais")
        val sms = root.obj("gestaoSms")
        val dds = root.array("dds")
            ?.mapNotNull { node ->
                val o = node as? JsonMap ?: return@mapNotNull null
                RelSegDdsEntry(temaData = o.str("temaData"), fotoRef = o.str("fotoRef"))
            }
            .orEmpty()
        val tre = root.array("treinamentos")
            ?.mapNotNull { node ->
                val o = node as? JsonMap ?: return@mapNotNull null
                RelSegTreinamento(
                    treinamento = o.str("treinamento"),
                    nomes = o.str("nomes"),
                    data = o.str("data"),
                    numPessoas = o.str("numPessoas"),
                    descricao = o.str("descricao"),
                    fotos = o.strList("fotos")
                ).withFotosSize()
            }
            .orEmpty()
        return RelSegPayload(
            dadosGerais = RelSegDadosGerais(
                empresa = dg?.str("empresa")?.ifBlank { "Htms Energia" } ?: "Htms Energia",
                cnpj = dg?.str("cnpj").orEmpty(),
                grauRisco = dg?.str("grauRisco").orEmpty(),
                obra = dg?.str("obra").orEmpty(),
                contrato = dg?.str("contrato").orEmpty(),
                vigencia = dg?.str("vigencia").orEmpty(),
                cliente = dg?.str("cliente").orEmpty(),
                efetivoHtms = dg?.str("efetivoHtms").orEmpty(),
                efetivoTerceiro = dg?.str("efetivoTerceiro").orEmpty()
            ),
            gestaoSms = RelSegGestaoSms(
                desviosGerais = intOpt(sms, "desviosGerais"),
                apr = sms?.str("apr").orEmpty(),
                pt = sms?.str("pt").orEmpty(),
                dds = sms?.str("dds").orEmpty(),
                treinamentos = sms?.str("treinamentos").orEmpty(),
                checklist = sms?.str("checklist").orEmpty(),
                acidentesFatais = intOpt(sms, "acidentesFatais"),
                acidentes = intOpt(sms, "acidentes"),
                lesoes = intOpt(sms, "lesoes"),
                quaseAcidentes = intOpt(sms, "quaseAcidentes")
            ),
            dds = dds,
            treinamentos = tre
        ).withDdsSize().withTreinamentosSize()
    }

    private fun intOpt(node: JsonMap?, key: String): Int? =
        node?.long(key)?.toInt() ?: node?.double(key)?.toInt()

    private fun dadosToJson(d: RelSegDadosGerais): String = buildString {
        append('{')
        append("\"empresa\":"); append(jsonStr(d.empresa)); append(',')
        append("\"cnpj\":"); append(jsonStr(d.cnpj)); append(',')
        append("\"grauRisco\":"); append(jsonStr(d.grauRisco)); append(',')
        append("\"obra\":"); append(jsonStr(d.obra)); append(',')
        append("\"contrato\":"); append(jsonStr(d.contrato)); append(',')
        append("\"vigencia\":"); append(jsonStr(d.vigencia)); append(',')
        append("\"cliente\":"); append(jsonStr(d.cliente)); append(',')
        append("\"efetivoHtms\":"); append(jsonStr(d.efetivoHtms)); append(',')
        append("\"efetivoTerceiro\":"); append(jsonStr(d.efetivoTerceiro))
        append('}')
    }

    private fun smsToJson(s: RelSegGestaoSms): String = buildString {
        append('{')
        fun num(key: String, v: Int?) {
            append("\"$key\":")
            if (v == null) append("null") else append(v)
            append(',')
        }
        num("desviosGerais", s.desviosGerais)
        append("\"apr\":"); append(jsonStr(s.apr)); append(',')
        append("\"pt\":"); append(jsonStr(s.pt)); append(',')
        append("\"dds\":"); append(jsonStr(s.dds)); append(',')
        append("\"treinamentos\":"); append(jsonStr(s.treinamentos)); append(',')
        append("\"checklist\":"); append(jsonStr(s.checklist)); append(',')
        num("acidentesFatais", s.acidentesFatais)
        num("acidentes", s.acidentes)
        num("lesoes", s.lesoes)
        append("\"quaseAcidentes\":")
        if (s.quaseAcidentes == null) append("null") else append(s.quaseAcidentes)
        append('}')
    }

    private fun jsonStr(s: String): String {
        val esc = s.replace("\\", "\\\\").replace("\"", "\\\"")
            .replace("\n", "\\n").replace("\r", "\\r").replace("\t", "\\t")
        return "\"$esc\""
    }
}